import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { OrganizationsState } from '../organizations/OrganizationsState';
import { useSubscription } from '@meraki-internal/state';
import { NavigationItemList } from './NavigationItemList';
import { CaremapSwitcher } from './CaremapSwitcher';
import { AddCareMapButton } from '../caremap/AddCareMapButton';
import { AppPrincipal, isCaremapViewer } from '../auth/AppPrincipal';

interface NewUINavigationListProps {
    closeMenuHandler?: () => void;
    popoverWidth?: number;
}

export const NewUINavigationList: React.FC<NewUINavigationListProps> = ({ closeMenuHandler, popoverWidth  }) => {
    const careMapState = useInstance(CareMapState);
    const isViewer = isCaremapViewer(useInstance(AppPrincipal));

    const orgState = useInstance(OrganizationsState);
    useSubscription(() => orgState);

    // don't show nav, that would direct user to create a personal caremap
    if (orgState.isOrgTeamMember() && !careMapState.getMostRecentCaremap()){
        return null;
    }

    const showAddButton = !orgState.isOrgTeamMember() && !isViewer;

    return (
        <NavigationItemList>
            {popoverWidth && !orgState.isOrgTeamMember() && (
                <CaremapSwitcher
                    popoverWidth={popoverWidth}
                    closeNav={async () => {
                        if (closeMenuHandler){
                            closeMenuHandler();
                            await new Promise(resolve => setTimeout(resolve, 350));
                        }
                    }}
                />
            )}

            {showAddButton && (
                <div style={{margin: 24}}>
                    <AddCareMapButton closeMenu={() => {
                        if (closeMenuHandler){
                            closeMenuHandler();
                        }
                    }} />
                </div>
            )}
        </NavigationItemList>
    );
};


